import React from 'react';
import {
  Button,
  Dialog,
  DialogSurface,
  DialogTitle,
  DialogBody,
  DialogContent,
} from '@fluentui/react-components';
import { Dismiss24Regular } from '@fluentui/react-icons';

interface WizardDialogProps {
  title: string;
  onClose: () => void;
  maxWidth?: string;
  maxHeight?: string;
  contentStyle?: React.CSSProperties;
  children: React.ReactNode;
}

export const WizardDialog: React.FC<WizardDialogProps> = ({
  title,
  onClose,
  maxWidth = '900px',
  maxHeight = '85vh',
  contentStyle,
  children,
}) => (
  <Dialog open={true} onOpenChange={(_, data) => !data.open && onClose()}>
    <DialogSurface style={{ maxWidth, maxHeight }}>
      <DialogBody>
        <DialogTitle
          action={
            <Button
              appearance="subtle"
              aria-label="Close dialog"
              title="Close dialog"
              icon={<Dismiss24Regular />}
              onClick={onClose}
            />
          }
        >
          {title}
        </DialogTitle>
        <DialogContent style={contentStyle}>
          {children}
        </DialogContent>
      </DialogBody>
    </DialogSurface>
  </Dialog>
);
